const e = {
  styles: {
    bullets: {
      width: "15px",
      height: "15px",
      borderStyle: "none",
      borderRadius: "30px",
      margin: "7px"
    },
    arrows: {
      width: "40px",
      height: " 40px",
      color: "white",
      borderStyle: "none",
      borderRadius: "30px",
      margin: "10px"
    }
  }
};
export {
  e as DefaultProps
};
